import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	REMINDER_ID_PARAM,
	REMINDER_SCROLL_PARAM,
	REMINDER_SCROLL_VALUE,
} from "web_myplann/NotificationCenter/Utils/reminderScrollParam";

const REMINDER_ENTITY_DETAIL_PATH: Record<
	ReminderEntityTypeEnum,
	(entityId: string) => string
> = {
	[ReminderEntityTypeEnum.Portfolio]: Routing.Portfolio.PortfolioDetail.path,
	[ReminderEntityTypeEnum.Property]: Routing.Portfolio.PropertyDetail.path,
	[ReminderEntityTypeEnum.IdentificationDocument]:
		Routing.Profile.PaperworkDetail.path,
};

export const buildReminderEntityRoute = (
	entityType: ReminderEntityTypeEnum,
	entityId: string,
	reminderId?: number | null,
): string => {
	const basePath = REMINDER_ENTITY_DETAIL_PATH[entityType](entityId);
	const separator = basePath.includes("?") ? "&" : "?";
	const route = `${basePath}${separator}${REMINDER_SCROLL_PARAM}=${REMINDER_SCROLL_VALUE}`;
	return reminderId != null
		? `${route}&${REMINDER_ID_PARAM}=${reminderId}`
		: route;
};
